import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const VenuesTable = ({ venues, onVenueAction }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const filteredVenues = venues?.filter(venue =>
    venue?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    venue?.location?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm">
      <div className="p-6 border-b border-border">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <h3 className="text-lg font-semibold text-foreground">Venues Management</h3>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={() => navigate('/create-venue')}
          >
            Add Venue
          </Button>
        </div>

        <div className="mt-4">
          <Input
            type="search"
            placeholder="Search venues by name or location..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Venue</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Location</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Capacity</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Events</th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">Status</th>
              <th className="text-right p-4 text-sm font-medium text-muted-foreground">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredVenues?.map((venue) => (
              <tr key={venue?.id} className="border-b border-border hover:bg-muted/30 transition-colors">
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-muted rounded-lg overflow-hidden flex-shrink-0">
                      <img
                        src={venue?.image}
                        alt={venue?.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.src = '/assets/images/no_image.png';
                        }}
                      />
                    </div>
                    <div>
                      <h4 className="font-medium text-foreground">{venue?.name}</h4>
                      <p className="text-sm text-muted-foreground">{venue?.type}</p>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">{venue?.location}</p>
                    <p className="text-sm text-muted-foreground">{venue?.address}</p>
                  </div>
                </td>
                <td className="p-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">{venue?.capacity?.toLocaleString()}</p>
                    <p className="text-sm text-muted-foreground">max capacity</p>
                  </div>
                </td>
                <td className="p-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">{venue?.activeEvents}</p>
                    <p className="text-sm text-muted-foreground">active events</p>
                  </div>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    venue?.status === 'active' ?'bg-success text-success-foreground' :'bg-muted text-muted-foreground'
                  }`}>
                    {venue?.status === 'active' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-end space-x-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Eye"
                      onClick={() => navigate(`/venue/${venue?.id}`)}
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Edit"
                      onClick={() => navigate(`/edit-venue/${venue?.id}`)}
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="MapPin"
                      onClick={() => window.open(`https://maps.google.com/?q=${venue?.coordinates?.lat},${venue?.coordinates?.lng}`, '_blank')}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {filteredVenues?.length === 0 && (
        <div className="p-8 text-center">
          <Icon name="MapPin" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h4 className="text-lg font-medium text-foreground mb-2">No venues found</h4>
          <p className="text-muted-foreground mb-4">
            {searchTerm 
              ? 'Try adjusting your search criteria' :'Add your first venue to start hosting events'
            }
          </p>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            onClick={() => navigate('/create-venue')}
          >
            Add Venue
          </Button>
        </div>
      )}
    </div>
  );
};

export default VenuesTable;